import { thunk } from 'easy-peasy'

const resetModel = {
  resetUser: thunk(async (actions, payload, { getStoreActions }) => {
    getStoreActions().auth.reset()
    getStoreActions().address.reset()
    getStoreActions().booking.reset()
    getStoreActions().payment.reset()
  }),

  resetBooking: thunk(async (actions, payload, { getStoreActions }) => {
    getStoreActions().order.reset()
    getStoreActions().booking.reset()
    getStoreActions().payment.reset()
  }),
}

export default resetModel
